module.exports = __webpack_public_path__ + "img/main_mockup_calendar.00835eed.png";